/**
 * Функция отзыва договора — `POST /legal/withdrawals` (§ 356a BGB).
 *
 * Аутентификация не требуется: § 356a Abs. 1 BGB обязывает держать функцию
 * «ständig verfügbar … und leicht zugänglich» весь срок отзыва, а вход за
 * одноразовым кодом из почты доступным её не делает.
 *
 * Момент получения ставит **сервер**: по Abs. 5 срок считается от отправки
 * через функцию, и локальные часы браузера на него влиять не могут. Поэтому
 * `received_at` только читается из ответа и никогда не вычисляется здесь.
 */

import { useMutation } from '@tanstack/react-query';

import { apiFetch } from '@shared/api/client';

export interface WithdrawalRequestInput {
  /** § 356a Abs. 2 Nr. 1. */
  consumer_name: string;
  /** § 356a Abs. 2 Nr. 2 — номер чека или заказа из письма. */
  contract_reference: string;
  /** § 356a Abs. 2 Nr. 3 — адрес для Eingangsbestätigung. */
  contact_email: string;
  locale: string;
}

export interface WithdrawalReceipt {
  request_id: string;
  /** ISO 8601, UTC. Серверный момент получения (Abs. 4–5). */
  received_at: string;
  /**
   * Найден ли договор по указанному номеру. Какой именно — не сообщается:
   * форма открыта без входа, и подтверждение существования чужого договора по
   * номеру чека было бы утечкой.
   */
  matched_order: boolean;
}

export function useSubmitWithdrawal() {
  return useMutation({
    mutationFn: (input: WithdrawalRequestInput) =>
      apiFetch<WithdrawalReceipt>('/legal/withdrawals', { method: 'POST', body: input }),
    // Повтора нет намеренно: заявление об отзыве — необратимое действие, и
    // автоматическая вторая отправка создала бы второе заявление.
    retry: false,
  });
}
